// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("../datadog");
require("channels");

import Cookies from "js-cookie";
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const initializeTurbo = () => {
  // Disable by default. Enable via `data-turbo="true"`.
  window.Turbo.session.drive = false;

  window.Turbo.StreamActions.rinsed_reload = function () {
    window.location.reload();
  };

  document.removeEventListener("turbo:load", initializeTurbo);
};

window.Turbo ? initializeTurbo() : document.addEventListener("turbo:load", initializeTurbo);

import Rails from "@rails/ujs";
window.Rails = Rails;
window.Rails.start();

window.Stimulus = Application.start();
const context = require.context("../controllers", true, /\.js$/);
Stimulus.load(definitionsFromContext(context));

Cookies.remove("timezone");
Cookies.set("timezone", encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone));

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
